import { useQuery } from '@/lib/useQuery';

/**
 * The published store logo from a storefront appearance ({ theme, media }):
 * { url, alt } or null. Resolves theme.logo through the media map the same way
 * the storefront does (StorefrontContext mediaUrl).
 */
export function logoFrom(appearance) {
  const ref = appearance && appearance.theme && appearance.theme.logo;
  if (!ref || ref.media_id == null) return null;
  const url = appearance.media && appearance.media[String(ref.media_id)];
  return url ? { url, alt: ref.alt || '' } : null;
}

/** The store's published logo for the back office (public read, so it works signed out); null until loaded or on error. */
export function useStoreLogo() {
  const { data } = useQuery('sfAppearance', {}, { select: (r) => logoFrom(r && r.data) });
  return data || null;
}
